import { CurrentFdjApplicationUserDetails } from './types';
import { useAuthenticatedCurrentUser } from '@eogile/agrements-common/src/security/CurrentUserContext';

export const useFdjAuthenticatedCurrentUser = () => {
  return useAuthenticatedCurrentUser<CurrentFdjApplicationUserDetails>();
};
